<template>
    <div @click="openModal" v-if="params.value !== null&&params.value !== undefined">
         <div class="justify-content-center d-flex">
     <b-icon class="mt-1 cursor-pointer"  icon="file-person" font-scale="3" variant="primary" ></b-icon>
     </div>
     <b-modal :id="modalId" hide-footer :title="params.value.title" size="lg">
         <b-container fluid>

       
        
         <b-row  class="mx-4">
              <b-col cols="6" v-for="(item, index) in params.value.data" :key="index" class="">
                   <h5>{{item.label}}</h5>
                   <p>{{item.value}}</p>
         </b-col>

         </b-row>
           </b-container>
        
        
    </b-modal>
    </div>
    <div v-else>
         <div class="justify-content-center d-flex">
             -
     <!-- <b-icon class="mt-1 cursor-pointer" disabled  icon="file-person" font-scale="3" style="color:#7d7d7d" ></b-icon> -->
     </div>

    </div>
   

    
</template>

<script>
export default {
    data () {
        
        return {
            // title:"ข้อมูลติดต่อ",
            // tel:{
            //     company_name:{
            //         label:"ชื่อบริษัท",
            //         value:"House of Dev Technology Co.Ltd.,"
            //     },
            //     TAX_ID:{
            //         label:"หมายเลขผู้เสียภาษี",
            //         value:"1234"
            //     },
            //     branch_type:{
            //         label:"ประเภทสาขา",
            //         value:"สำนักงานใหญ่"
            //     },
            //     branch_no:{
            //         label:"สาขาเลขที่",
            //         value:"101"

            //     }
            // }

        }
    },mounted () {
    //    this.$root.$emit('bv::show::modal', `1`)
    //    let data_1 = this.params.data.id === 1 ? this.params.value:null
    //    console.log(data_1);
    },
    methods: {
        openModal() {
             this.$root.$emit('bv::show::modal', `${this.params.data.id}`)
             console.log("this.params",this.params.value);
            
        }
    },computed: {
        modalId() {
            return `${this.params.data.id}`
        }
    },
}
</script>

<style >
.modal-content {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    pointer-events: auto;
    outline: 0;
    top: 200px;
    left: 20%;
}
</style>